/* eslint-disable react/prop-types */
import React from 'react';
import ParticipationRate from '../ParticipationRate';

/**
 * Headline metric cards for the activity-log pages (036) on the shared au-card system.
 * Logs (record count, with a period delta) and Users (distinct users, with a delta,
 * the feature-024 participation rate, and the "Subscribed" count). Every value is
 * text + value; deltas carry text + icon (never colour alone); tabular numerals.
 */
const ICONS = { up: '▲', down: '▼', flat: '—', new: '★' };
const DELTA_CLASS = { up: 'au-delta--up', down: 'au-delta--down', flat: 'au-delta--flat', new: 'au-delta--flat' };

const Delta = ({ delta }) => {
  if (!delta || !delta.direction) return null;
  const { direction, delta_pct: pct } = delta;
  const pill = direction === 'new'
    ? `${ICONS.new} new`
    : direction === 'flat'
      ? `${ICONS.flat} 0%`
      : `${ICONS[direction]} ${Math.abs(pct)}%`;
  const label = direction === 'new' ? 'this period' : 'vs prior period';
  return (
    <span className="al-delta" aria-label={`${pill} ${label}`}>
      <span className={`au-delta ${DELTA_CLASS[direction]}`}>{pill}</span>
      <span className="al-delta__lbl">{label}</span>
    </span>
  );
};

const n = (v) => Number(v || 0).toLocaleString();

const ActivityLogSummaryCards = ({
  logs = 0,
  users = 0,
  totalUserBase = 0,
  subscribedUserCount = 0,
  logsDelta = null,
  usersDelta = null,
}) => (
  <div className="au-cards" data-testid="al-summary">
    <div className="au-card">
      <span className="au-card__label">Logs</span>
      <span className="au-card__value tnum">{n(logs)}</span>
      <Delta delta={logsDelta} />
    </div>
    <div className="au-card">
      <span className="au-card__label">Users</span>
      <span className="au-card__value tnum">{n(users)}</span>
      <ParticipationRate className="au-card__sub" count={users} total={totalUserBase} />
      <span className="au-card__sub" data-testid="al-subscribed">Subscribed: {n(subscribedUserCount)}</span>
      <Delta delta={usersDelta} />
    </div>
  </div>
);

export default ActivityLogSummaryCards;
